<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>渠道管理</h1>
        <p>全平台渠道档案。开设账号后由总部审核，通过才生成邀请码。代金券不能由上级划给下级。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn gold" type="button" @click="open = true">开设渠道账号</button>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">渠道总数</div><div class="v">{{ rows.length }}</div></div>
      <div class="ch-metric"><div class="k">已通过</div><div class="v">{{ count('APPROVED') }}</div></div>
      <div class="ch-metric"><div class="k">待审核</div><div class="v">{{ count('PENDING') }}</div></div>
    </div>
    <div class="ch-panel">
      <p v-if="keyword" class="ch-note" style="margin-bottom:12px">当前筛选：{{ keyword }}</p>
      <table class="ch-table">
        <thead><tr><th>渠道商</th><th>上级</th><th>级别</th><th>区域</th><th>手机</th><th>邀请码</th><th>状态</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in shown" :key="row.id">
            <td>{{ row.name }}</td>
            <td>{{ parentName(row.parentId) }}</td>
            <td>{{ levelName(row.levelCode) }}</td>
            <td>{{ row.regionName || '—' }}</td>
            <td>{{ row.phone || '—' }}</td>
            <td>{{ row.inviteCode || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 'APPROVED' ? 'ok' : (row.status === 'REJECTED' ? 'bad' : 'warn')">{{ statusName(row.status) }}</span></td>
            <td>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'approve')">通过</button>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'reject')">驳回</button>
              <button v-if="row.status === 'APPROVED'" class="ch-link" type="button" @click="referrer(row)">推荐人</button>
              <button v-if="row.status === 'APPROVED'" class="ch-link" type="button" @click="openLevel(row)">改级别</button>
              <button v-if="row.status === 'APPROVED' && row.levelCode === 'ECO'" class="ch-link" type="button" @click="openShare(row)">录入分成</button>
              <button v-if="row.status === 'APPROVED'" class="ch-link" type="button" @click="openPassword(row)">修改密码</button>
            </td>
          </tr>
          <tr v-if="!shown.length"><td colspan="8" class="ch-empty">没有匹配的渠道</td></tr>
        </tbody>
      </table>
    </div>
    <el-dialog title="开设渠道账号" :visible.sync="open" width="520px">
      <el-form label-width="90px" size="small">
        <el-form-item label="级别">
          <el-select v-model="form.levelCode">
            <el-option v-for="(name, code) in levels" :key="code" :label="name" :value="code" />
          </el-select>
        </el-form-item>
        <el-form-item label="主体"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="手机"><el-input v-model="form.phone" /></el-form-item>
        <el-form-item label="法人"><el-input v-model="form.legalName" /></el-form-item>
        <el-form-item label="执照号"><el-input v-model="form.licenseNo" /></el-form-item>
        <el-form-item label="区划代码"><el-input v-model="form.regionCode" /></el-form-item>
        <el-form-item label="地区名"><el-input v-model="form.regionName" /></el-form-item>
        <el-form-item label="上级ID"><el-input v-model="form.parentId" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="open = false">取消</el-button>
        <el-button size="small" @click="submit(false)">提交审核</el-button>
        <el-button size="small" type="primary" @click="submit(true)">代录并通过</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改级别" :visible.sync="levelOpen" width="420px">
      <el-form label-width="90px" size="small">
        <el-form-item label="级别">
          <el-select v-model="levelForm.levelCode">
            <el-option v-for="(name, code) in levels" :key="code" :label="name" :value="code" />
          </el-select>
        </el-form-item>
        <el-form-item label="上级ID"><el-input v-model="levelForm.parentId" placeholder="级别变了才需要改" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="levelOpen = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveLevel">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="录入项目分成" :visible.sync="shareOpen" width="420px">
      <p class="ch-note">比例在 5% 到 10% 之间，按这次项目手工填写。已经结过的账不会重算。</p>
      <el-form label-width="90px" size="small">
        <el-form-item label="比例"><el-input v-model="shareForm.rate" placeholder="0.05 到 0.10" /></el-form-item>
        <el-form-item label="基数(元)"><el-input v-model="shareForm.baseAmount" /></el-form-item>
        <el-form-item label="说明"><el-input v-model="shareForm.note" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="shareOpen = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveShare">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="passwordOpen" width="420px">
      <p class="ch-note">登录账号为渠道商手机号：{{ passwordForm.phone || '—' }}</p>
      <el-form label-width="90px" size="small">
        <el-form-item label="新密码"><el-input v-model="passwordForm.password" type="password" show-password placeholder="至少 6 位" /></el-form-item>
        <el-form-item label="确认密码"><el-input v-model="passwordForm.confirm" type="password" show-password /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="passwordOpen = false">取消</el-button>
        <el-button size="small" type="primary" @click="savePassword">保存</el-button>
      </div>
    </el-dialog>
    <div class="ch-panel">
      <h2>渠道经理管辖</h2>
      <p class="ch-note">由渠道总监分配。区划填省或城市代码，例如 370000、370100。经理只能看到这些地区里的渠道。</p>
      <div style="display:flex;gap:8px;margin-bottom:12px">
        <input v-model="scope.username" placeholder="经理登录名" style="padding:8px;border:1px solid #e7ebf3;border-radius:8px" />
        <input v-model="scope.regionCode" placeholder="省或城市区划代码" style="padding:8px;border:1px solid #e7ebf3;border-radius:8px" />
        <input v-model="scope.regionName" placeholder="地区名称" style="padding:8px;border:1px solid #e7ebf3;border-radius:8px" />
        <button class="ch-btn primary" type="button" @click="assignScope">分配</button>
      </div>
      <table class="ch-table">
        <thead><tr><th>经理</th><th>区划</th><th>地区</th><th></th></tr></thead>
        <tbody>
          <tr v-for="row in scopes" :key="row.id">
            <td>{{ row.realName || row.username }}</td>
            <td>{{ row.regionCode }}</td>
            <td>{{ row.regionName || '—' }}</td>
            <td><button class="ch-link" type="button" @click="removeScope(row)">移除</button></td>
          </tr>
          <tr v-if="!scopes.length"><td colspan="4" class="ch-empty">还没有分配管辖范围</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelPartners, saveChannelPartner, reviewChannelPartner, setChannelReferrer, changeChannelLevel, changeChannelPassword, getManagerScopes, saveManagerScope, saveEcoShare } from '@/api/admin'
import { LEVELS, levelName, statusName } from '../partner/labels'

export default {
  name: 'HqPartners',
  data() {
    return {
      rows: [], open: false, levelOpen: false, shareOpen: false, passwordOpen: false, levels: LEVELS, scopes: [],
      form: { levelCode: 'DISTRICT', name: '', phone: '', legalName: '', licenseNo: '', regionCode: '', regionName: '', parentId: '' },
      levelForm: { id: '', levelCode: 'DISTRICT', parentId: '' },
      shareForm: { partnerId: '', rate: '0.05', baseAmount: '', note: '' },
      passwordForm: { id: '', phone: '', password: '', confirm: '' },
      scope: { username: '', regionCode: '', regionName: '' }
    }
  },
  computed: {
    keyword() { return ((this.$route.query && this.$route.query.keyword) || '').trim() },
    shown() {
      if (!this.keyword) return this.rows
      return this.rows.filter(item => [item.name, item.regionName, item.phone, item.inviteCode].join(' ').indexOf(this.keyword) >= 0)
    }
  },
  created() { this.load() },
  methods: {
    levelName, statusName,
    count(status) { return this.rows.filter(item => item.status === status).length },
    parentName(id) {
      if (!id) return '—'
      const parent = this.rows.find(item => String(item.id) === String(id))
      return parent ? parent.name : id
    },
    async load() {
      const partners = await getChannelPartners()
      this.rows = partners.list || []
      try {
        const scopes = await getManagerScopes()
        this.scopes = scopes.list || []
      } catch (e) {
        this.scopes = []
      }
    },
    async submit(approveNow) {
      const body = { ...this.form, approveNow }
      if (!body.parentId) delete body.parentId
      const result = await saveChannelPartner(body)
      this.open = false
      if (result && result.initialPassword) {
        this.$alert(`登录名 ${result.loginName}，初始密码 ${result.initialPassword}`, '账号已开通')
      }
      this.load()
    },
    async review(row, action) {
      let reason = ''
      if (action === 'reject') {
        const input = await this.$prompt('驳回原因', '驳回')
        reason = input.value
      }
      const result = await reviewChannelPartner(row.id, { action, reason })
      if (result && result.initialPassword) {
        this.$alert(`登录名 ${result.loginName}，初始密码 ${result.initialPassword}，邀请码 ${result.inviteCode}`, '已通过')
      }
      this.load()
    },
    async referrer(row) {
      const input = await this.$prompt('推荐人渠道 ID，留空表示清空', '推荐人', { inputValue: row.referrerId || '' })
      await setChannelReferrer(row.id, { referrerId: input.value || null })
      this.load()
    },
    openLevel(row) {
      this.levelForm = { id: row.id, levelCode: row.levelCode, parentId: row.parentId || '' }
      this.levelOpen = true
    },
    async saveLevel() {
      const body = { levelCode: this.levelForm.levelCode }
      if (this.levelForm.parentId) body.parentId = this.levelForm.parentId
      await changeChannelLevel(this.levelForm.id, body)
      this.levelOpen = false
      this.load()
    },
    openShare(row) {
      this.shareForm = { partnerId: row.id, rate: '0.05', baseAmount: '', note: '' }
      this.shareOpen = true
    },
    async saveShare() {
      await saveEcoShare(this.shareForm)
      this.shareOpen = false
      this.$message.success('已记入分成，下期月结一起算')
    },
    openPassword(row) {
      this.passwordForm = { id: row.id, phone: row.phone || '', password: '', confirm: '' }
      this.passwordOpen = true
    },
    async savePassword() {
      const pwd = (this.passwordForm.password || '').trim()
      if (pwd.length < 6) {
        this.$message.warning('密码至少 6 位')
        return
      }
      if (pwd !== (this.passwordForm.confirm || '').trim()) {
        this.$message.warning('两次输入的密码不一致')
        return
      }
      const result = await changeChannelPassword(this.passwordForm.id, { password: pwd })
      this.passwordOpen = false
      this.$message.success(`已更新，登录账号 ${result.loginName || this.passwordForm.phone}`)
    },
    async assignScope() {
      if (!this.scope.username || !this.scope.regionCode) return
      await saveManagerScope(this.scope)
      this.scope = { username: '', regionCode: '', regionName: '' }
      this.load()
    },
    async removeScope(row) {
      await saveManagerScope({ username: row.username, regionCode: row.regionCode, action: 'remove' })
      this.load()
    }
  }
}
</script>
